(function () {
  if (window.__lybc) return;
  window.__lybc = 1;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function drawer(open) {
    var d = $('[data-lybc-drawer]');
    if (!d) return;
    d.classList.toggle('is-open', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  function more(btn) {
    var url = btn.getAttribute('data-next');
    if (!url || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Loading';
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = $('[data-lybc-grid]');
      $$('[data-lybc-grid] > *', doc).forEach(function (n) { grid.appendChild(document.importNode(n, true)); });
      var box = $('[data-lybc-morebox]');
      var nbox = $('[data-lybc-morebox]', doc);
      if (nbox) { box.innerHTML = nbox.innerHTML; } else { box.remove(); }
    }).catch(function () { btn.disabled = false; btn.textContent = 'Load more'; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-lybc-open]')) { drawer(true); return; }
    if (t.closest('[data-lybc-close]')) { drawer(false); return; }
    var sb = t.closest('[data-lybc-sortbtn]');
    if (sb) { sb.closest('.lybc-sort').classList.toggle('is-open'); return; }
    var so = t.closest('[data-lybc-sort]');
    if (so) {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', so.getAttribute('data-lybc-sort'));
      u.searchParams.delete('page');
      location.href = u.toString();
      return;
    }
    $$('.lybc-sort.is-open').forEach(function (s) { s.classList.remove('is-open'); });
    var g = t.closest('[data-lybc-cols]');
    if (g) {
      var grid = $('[data-lybc-grid]');
      if (grid) grid.style.setProperty('--cols', g.getAttribute('data-lybc-cols'));
      $$('[data-lybc-cols]').forEach(function (b) { b.classList.toggle('is-on', b === g); });
      return;
    }
    var m = t.closest('[data-lybc-more]');
    if (m) { e.preventDefault(); more(m); }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer(false); });

  // filter panel: keep the "Show n pieces" button in step with the ticked boxes
  document.addEventListener('change', function (e) {
    var form = e.target.closest ? e.target.closest('[data-lybc-form]') : null;
    if (!form) return;
    var p = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') p.append(k, v); });
    var btn = $('[data-lybc-show]', form);
    fetch(form.action + '?' + p.toString()).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var c = $('[data-lybc-total]', doc);
      if (!c || !btn) return;
      var n = c.getAttribute('data-lybc-total');
      btn.textContent = 'Show ' + n + (n === '1' ? ' piece' : ' pieces');
    });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-lybc-form]')) return;
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.name && el.type === 'number' && el.value === '') el.disabled = true;
    });
  });
})();
